import colors from "assets/theme-dark/base/colors";
import typography from "assets/theme-dark/base/typography";
import boxShadows from "assets/theme-dark/base/boxShadows";

// Argon Dashboard 2 MUI Helper Functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { primary, white, info, secondary, warning, error, success } = colors;
const { size } = typography;
const { buttonBoxShadow } = boxShadows;

const contained = {
    base: {
        backgroundColor: white.main,
        minHeight: pxToRem(40),
        color: white.main,
        boxShadow: buttonBoxShadow.main,
        padding: `${pxToRem(10)} ${pxToRem(20)}`,

        "&:hover": {
            backgroundColor: white.main,
            boxShadow: buttonBoxShadow.stateOf,
        },

        "&:focus": {
            boxShadow: buttonBoxShadow.stateOf,
        },

        "&:active, &:active:focus, &:active:hover": {
            opacity: 0.85,
            boxShadow: buttonBoxShadow.stateOf,
        },

        "&:disabled": {
            boxShadow: buttonBoxShadow.main,
        },

        "& .material-icon, .material-icons-round, svg": {
            fontSize: `${pxToRem(16)} !important`,
        },
    },

    small: {
        minHeight: pxToRem(32),
        padding: `${pxToRem(8)} ${pxToRem(32)}`,
        fontSize: size.xs,

        "& .material-icon, .material-icons-round, svg": {
            fontSize: `${pxToRem(12)} !important`,
        },
    },

    large: {
        minHeight: pxToRem(47),
        padding: `${pxToRem(14)} ${pxToRem(64)}`,
        fontSize: size.sm,

        "& .material-icon, .material-icons-round, svg": {
            fontSize: `${pxToRem(22)} !important`,
        },
    },

    primary: {
        backgroundColor: primary.main,

        "&:hover": {
            backgroundColor: primary.focus,
        },

        "&:focus:not(:hover)": {
            backgroundColor: primary.focus,
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },

    secondary: {
        backgroundColor: secondary.main,

        "&:hover": {
            backgroundColor: secondary.focus,
        },

        "&:focus:not(:hover)": {
            backgroundColor: secondary.focus,
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },

    error: {
        backgroundColor: error.main,

        "&:hover": {
            backgroundColor: error.focus,
        },

        "&:focus:not(:hover)": {
            backgroundColor: error.focus,
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },

    warning: {
        backgroundColor: warning.main,

        "&:hover": {
            backgroundColor: warning.focus,
        },

        "&:focus:not(:hover)": {
            backgroundColor: warning.focus,
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },
    
    info: {
        backgroundColor: info.main,

        "&:hover": {
            backgroundColor: info.focus,
        },

        "&:focus:not(:hover)": {
            backgroundColor: info.focus,
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },
    
    success: {
        backgroundColor: success.main,

        "&:hover": {
            backgroundColor: success.focus,
        },

        "&:focus:not(:hover)": {
            backgroundColor: success.focus,
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },
};

export default contained;
